import React from "react"

const Card = ({ title, imgid, desc, sourceUrl }) => {
  const imageUrl = `http://drive.google.com/uc?export=view&id=${imgid}`

  const source = `https://github.com/hardik239/${sourceUrl}`

  return (
    <div className="col-lg-4 col-md-6 p-4 mb-5" data-aos="fade-up">
      <div className="card shadow">
        <div className="inner">
          <img src={imageUrl} className="card-img-top" alt={title} />
        </div>
        <div className="card-body text-center">
          <h5 className="card-title text-primary">{title}</h5>
          <p className="card-text">{desc}</p>
          <a
            href={source}
            target="_blank"
            className="btn btn-primary"
            rel="noopener noreferrer">
            View Code
          </a>
        </div>
      </div>
    </div>
  )
}

export default Card
